<div class="backgroud" id="cmvloading">
	<div class="cmv-content" #toastContainer>
		<router-outlet></router-outlet>
	</div>
</div>
<cmv-full-size-loading
	[isModalOpen]="loading$ | async"
	[loadingMessage]="message$ | async"></cmv-full-size-loading>
